const sameCategory = (a: string, b: string) => a.trim().toLocaleLowerCase() === b.trim().toLocaleLowerCase();

export const distinctCategories = (categories: string[]): string[] =>
  categories
    .map((category) => category.trim())
    .filter((category, index, all) => category.length > 0 && all.findIndex((c) => sameCategory(c, category)) === index);

export const repeatsAnEarlierCategory = (categories: string[], index: number): boolean =>
  categories[index].trim().length > 0 && categories.slice(0, index).some((c) => sameCategory(c, categories[index]));
